import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

import theme from '../muiTheme';

const Splash = (props) => {
  return (
    <div className="splash-container">
      <CircularProgress size={140} thickness={3} color={theme.palette.canvasColor} className="splash-spinner" />
      <h2>NIFC INSPECTOR</h2>
    </div>
  );
}

export default Splash;
